/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.image_reactivation';
export const Component = loadable(
  () => import('./containers/ImageReactivationContainer')
);
export { default as propsFormatter } from './propsFormatter';
